import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { PasswordPolicyDto } from '../../core/api/model/passwordPolicyDto';

const COMPONENTS_SCOPE = 'components';
const REQUIREMENTS_KEY = 'passwordRequirements';

/**
 * Builds the dynamic password requirements sentence from the API policy.
 * Format: "Ihr Passwort muss aus {min} Zeichen bestehen und (a), (b), ... und (n) enthalten."
 * Uses components.passwordRequirements.template and the requirement labels from i18n.
 */
@Pipe({
  name: 'passwordRequirementsText',
  standalone: true
})
export class PasswordRequirementsPipe implements PipeTransform {
  private readonly _transloco = inject(TranslocoService);

  transform(policy: PasswordPolicyDto | null | undefined): string {
    if (!policy) {
      return '';
    }
    const labels: string[] = [];
    if (policy.requireLowercase) {
      labels.push(this._transloco.translate(`${REQUIREMENTS_KEY}.requireLowercase`, {}, COMPONENTS_SCOPE));
    }
    if (policy.requireUppercase) {
      labels.push(this._transloco.translate(`${REQUIREMENTS_KEY}.requireUppercase`, {}, COMPONENTS_SCOPE));
    }
    if (policy.requireDigit) {
      labels.push(this._transloco.translate(`${REQUIREMENTS_KEY}.requireDigit`, {}, COMPONENTS_SCOPE));
    }
    if (policy.requireSpecialCharacter) {
      labels.push(this._transloco.translate(`${REQUIREMENTS_KEY}.requireSpecialCharacter`, {}, COMPONENTS_SCOPE));
    }
    const andWord = this._transloco.getActiveLang() === 'de' ? ' und ' : ' and ';
    const requirements =
      labels.length === 0 ? '' : labels.length === 1 ? labels[0] : labels.slice(0, -1).join(', ') + andWord + labels[labels.length - 1];
    return this._transloco.translate(`${REQUIREMENTS_KEY}.template`, { min: policy.minLength, requirements }, COMPONENTS_SCOPE);
  }
}
